<template>
    <div class="schedule-table">
        <el-popover id="my_popover" ref="my_popover" style="visibility:hidden;" placement="right" v-model="popoverVisible">
            <div style="margin-bottom:12px;">
                <el-checkbox v-model="realRepeatDate.isRepeatDate" @change="upDatePopover">周期性</el-checkbox>
                <i v-if="realRepeatDate.isRepeatDate" style="float: right;cursor: pointer;" class="el-icon-minus" @click="minMyPopper"></i>
            </div>
            <div v-if="realRepeatDate.isRepeatDate">
                <div style="margin-bottom:12px;">
                    <div style="color:#24d47b;">{{realRepeatDate.repeatType===0?'每天':'每周'}}</div>
                    <span>课程将{{realRepeatDate.repeatType===0?'每天':'于每周'}}重复</span>
                    <div>开始于{{realRepeatDate.startDate}}</div>
                    <div>结束于{{format(endDate,'YYYY-MM-DD')}} , 共{{realRepeatDate.limitType===0?realRepeatDate.times:numOfCourse}}次课程</div>
                </div>
                <el-select style="margin-bottom:20px;" v-model="realRepeatDate.repeatType" size="small">
                    <el-option :value="0" label="每天">每天</el-option>
                    <el-option :value="1" label="每周">每周</el-option>
                </el-select>
                <div style="margin-bottom:12px;">结束重复</div>
                <el-select style="margin:0 6px 20px 0;" v-model="realRepeatDate.limitType" size="small">
                    <el-option :value="0" label="限定会议次数">限定会议次数</el-option>
                    <el-option :value="1" label="限定结束日期">限定结束日期</el-option>
                </el-select>
                <el-input-number v-if="realRepeatDate.limitType===0" controls-position="right" size="small" v-model="realRepeatDate.times" :min="1">
                </el-input-number>
                <el-date-picker v-else size="small" v-model="realRepeatDate.closingDate" :picker-options="pickerOptions"></el-date-picker>
                <div style="text-align:right;">
                    <el-button size="small" type="primary" @click="handleRepeatDate(realRepeatDate.courseId)">保存</el-button>
                </div>
            </div>
            <div slot="reference" style="width:100%;height:100%;"></div>
        </el-popover>
        <div class="time-slot-box">
            <div class="time-slot-head">
                <div class="now-date">{{monthEnglish[nowMonth-1]+ '  '+ nowYear}}</div>
                <div class="start-end-time">{{nowYear +' '+ startTime+'-'+ endTime}}</div>
                <div class="time-operate">
                    <span class="time-slot-oprate" @click="clearCourse">Reset</span>
                    <i class="el-icon-back" style="margin-right:9px;" @click="changeWeek('prev-week')"></i>
                    <i class="el-icon-right" @click="changeWeek('next-week')"></i>
                </div>
            </div>
            <el-table :data="dateweek" border style="width: 100%; margin-top: 20px">
                <el-table-column class-name="hour-time" label="Time" width="60"> </el-table-column>
                <el-table-column prop="sun" label="Sunday"> </el-table-column>
                <el-table-column prop="mon" label="Monday"> </el-table-column>
                <el-table-column prop="tues" label="Tuesday"> </el-table-column>
                <el-table-column prop="wed" label="Wednesday"> </el-table-column>
                <el-table-column prop="thur" label="Thursday"> </el-table-column>
                <el-table-column prop="fri" label="Friday"> </el-table-column>
                <el-table-column prop="sat" label="Saturday"> </el-table-column>
            </el-table>
            <el-scrollbar style="height: 80vh;margin-bottom:8px;">

                <el-table class="table-body" :data="scheduleData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 0px" :show-header="false" @cell-click="clickSchedule" :cell-style="setCellStyle" @cell-contextmenu="mouseclick">
                    <el-table-column class-name="hour-time" prop="hour" label="Time" width="60"> </el-table-column>

                    <el-table-column prop="sun" label="Sunday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.sun['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.sun['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.sun.apdate+'  '+scope.row.sun.starttime + '-'+scope.row.sun.endtime }}</div>
                                    <div v-if="scope.row.sun&&scope.row.sun['covey_user.realname']" class="schedule-popover-item">{{scope.row.sun.caltype===0 ?'Tutor: ':'Student: '+scope.row.sun['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.sun['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.sun['covey_course.courseName']}}</div>

                        </template>
                    </el-table-column>

                    <el-table-column prop="mon" label="Monday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.mon['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.mon['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.mon.apdate+'  '+scope.row.mon.starttime + '-'+scope.row.mon.endtime }}</div>
                                    <div v-if="scope.row.mon&&scope.row.mon['covey_user.realname']" class="schedule-popover-item">{{scope.row.mon.caltype===0 ?'Tutor: ':'Student: '+scope.row.mon['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.mon['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.mon['covey_course.courseName']}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="tues" label="Tuesday">
                        <template slot-scope="scope">

                            <el-popover v-if="scope.row.tues['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.tues['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.tues.apdate+'  '+scope.row.tues.starttime + '-'+scope.row.tues.endtime }}</div>
                                    <div v-if="scope.row.tues&&scope.row.tues['covey_user.realname']" class="schedule-popover-item">{{scope.row.tues.caltype===0 ?'Tutor: ':'Student: '+scope.row.tues['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.tues['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.tues['covey_course.courseName']}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="wed" label="Wednesday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.wed['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.wed['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.wed.apdate+'  '+scope.row.wed.starttime + '-'+scope.row.wed.endtime }}</div>
                                    <div v-if="scope.row.wed&&scope.row.wed['covey_user.realname']" class="schedule-popover-item">{{scope.row.wed.caltype===0 ?'Tutor: ':'Student: '+scope.row.wed['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.wed['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.wed['covey_course.courseName']}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="thur" label="Thursday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.thur['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.thur['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.thur.apdate+'  '+scope.row.thur.starttime + '-'+scope.row.thur.endtime }}</div>
                                    <div v-if="scope.row.thur&&scope.row.thur['covey_user.realname']" class="schedule-popover-item">{{scope.row.thur.caltype===0 ?'Tutor: ':'Student: '+scope.row.thur['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.thur['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.thur['covey_course.courseName']}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="fri" label="Friday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.fri['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.fri['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.fri.apdate+'  '+scope.row.fri.starttime + '-'+scope.row.fri.endtime }}</div>
                                    <div v-if="scope.row.fri&&scope.row.fri['covey_user.realname']" class="schedule-popover-item">{{scope.row.fri.caltype===0 ?'Tutor: ':'Student: '+scope.row.fri['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.fri['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.fri['covey_course.courseName']}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="sat" label="Saturday">
                        <template slot-scope="scope">
                            <el-popover v-if="scope.row.sat['covey_course.courseName']" popper-class="schedule-popover" trigger="hover" placement="right">
                                <div>
                                    <div class="schedule-popover-title">{{ scope.row.sat['covey_course.courseName'] }}</div>
                                    <div class="schedule-popover-item">{{ scope.row.sat.apdate+'  '+scope.row.sat.starttime + '-'+scope.row.sat.endtime }}</div>
                                    <div v-if="scope.row.sat&&scope.row.sat['covey_user.realname']" class="schedule-popover-item">{{scope.row.sat.caltype===0 ?'Tutor: ':'Student: '+scope.row.sat['covey_user.realname']}}</div>
                                </div>
                                <div slot="reference">
                                    {{ scope.row.sat['covey_course.courseName'] }}
                                </div>
                            </el-popover>
                            <div v-else>{{scope.row.sat['covey_course.courseName']}}</div>

                            <!-- <el-popover v-if="scope.row.col.length>0 && scope.row.col.includes(arr[WEEK2DATE[scope.column.label]])" trigger="hover" placement="right">
                                <div slot="reference" style="width:100%;height:20px;content:'1 ';"></div>
                            </el-popover> -->
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
var WEEKMAP = ['sun', 'mon', 'tues', 'wed', 'thur', 'fri', 'sat']
var WEEKMAP_ = {

    'sun': 'Sunday',
    'mon': 'Monday',
    'tues': 'Tuesday',
    'wed': 'Wednesday',
    'thur': 'Thursday',
    'fri': 'Friday',
    'sat': 'Saturday',
}
var WEEKMAP_EN = {
    'Sunday': 'sun',
    'Monday': 'mon',
    'Tuesday': 'tues',
    'Wednesday': 'wed',
    'Thursday': 'thur',
    'Friday': 'fri',
    'Saturday': 'sat',
}
var WEEK2DATE = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6,
}
import { format } from "@/utils/comm";
export default {
    name: 'schedule-table',
    props: {
        repeatAble: {//repeatAble 控制 每周重复 每日重复;
            require: false,
            type: Boolean,
            default: false
        },
        // https://blog.csdn.net/l1996729/article/details/106354377/      
        // props为Array时，直接默认[]会报错： Props with type Object/Array must use a factory function to return the default value.
        // 解决方法： default:()=>[]
        highlightTable: {//highlightTable 修改时间的时候 高亮展示的课程 highlightTable
            require: false,
            type: Array,
            default: () => [],
        },
        multiple: {//控制多选，修改课程时只能选择一次课
            require: false,
            type: Boolean,
            default: true
        },
        classSlot: {//一次选几节课 默认2节一个小时
            require: false,
            type: Number,
            default: 2
        }
    },
    watch: {
        tempSchedule: function (newVal, oldVal) {
            this.$emit('TempSchedule', newVal);
        }
    },
    computed: {
        dateweek() {//表头
            let array = [];
            let obj = {};
            this.arr.forEach((item, i) => {
                let ary = item.split("-");
                let tem = 'th'
                if ((ary[2] + '') === '1') tem = 'st';
                if ((ary[2] + '') === '2') tem = 'nd';
                if ((ary[2] + '') === '3') tem = 'rd';
                obj[WEEKMAP[i]] = ary[2] + tem;
            });

            array.push(obj);
            return array;
        },
        tempSchedule() {
            let date_set = new Set();
            let tempSchedule = []
            for (let week_item of this.weekListe) {
                for (let item of week_item.col) {
                    date_set.add(item)
                }
            }
            date_set = Array.from(date_set).sort();
            for (let key of date_set) {

                for (let i = 0; i < this.weekListe.length; i++) {

                    if (this.weekListe[i].col.includes(key)) {
                        let temp_data = this.weekListe[i];
                        let j = 1;
                        while (this.weekListe[i + 1] && this.weekListe[++i].col.includes(key)) j++;

                        let endtime_h = temp_data.hour + parseInt(j / 2);
                        let endtime_m = (j % 2) * 30 + (temp_data.period === 1 ? 0 : 30);

                        if (endtime_m == 60) {
                            endtime_h++;
                            endtime_m = '00';
                        } else if (endtime_m == 30) {
                            endtime_m = '30';
                        } else {
                            endtime_m = '00';
                        }
                        tempSchedule.push({
                            tempId: key + '-' + temp_data.hour + '-' + temp_data.period,
                            apdate: key,
                            week: WEEKMAP[new Date(key.replaceAll('-', '/')).getDay()],
                            hour: temp_data.hour,
                            period: temp_data.period,
                            starttime: temp_data.hour + ':' + (temp_data.period === 1 ? '00' : '30'),
                            endtime: endtime_h + ':' + endtime_m,
                            slot: j
                        })
                    }
                }
            }
            return tempSchedule
        },
        numOfCourse() {
            let circle = this.realRepeatDate.repeatType === 0 ? 1 : 7;
            let startDate = new Date(this.realRepeatDate.startDate).valueOf(); //开始日期
            let endDate = this.realRepeatDate.closingDate.valueOf() + 8 * 60 * 60 *3000;//结束日期

            

            this.realRepeatDate.times = Math.abs(parseInt((endDate - startDate) / (24 * 60 * 60 * 1000 * circle)+ 1) || 0);
            return Math.abs(parseInt((endDate - startDate) / (24 * 60 * 60 * 1000 * circle) + 1) || 0)
        },
        endDate() {//周期性时，课程结束日期
            let res = ''
            let circle = this.realRepeatDate.repeatType === 0 ? 1 : 7;
            let startDate = this.realRepeatDate.startDate;//开始日期
            let times = this.realRepeatDate.times;//次数

            let endDate = this.realRepeatDate.closingDate;//结束日期
            if (this.realRepeatDate.limitType === 0) {
                res = new Date(new Date(startDate).valueOf() + 24 * 60 * 60 * 1000 * circle * (times - 1))
            } else {
                res = endDate
            }


            return res
        },
        repeatDate() {
            let res = [];
            for (let item of this.tempSchedule) {
                res.push({
                    courseId: item.tempId,
                    isRepeatDate: false,
                    repeatType: 0,
                    limitType: 0,
                    times: 0,
                    closingDate: '',
                    startDate: item.apdate,
                    slot: item.slot
                })
            }
            return res
        }
    },
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now();
                },
            },
            format: format,
            arr: [],
            WEEK2DATE: WEEK2DATE,
            WEEKMAP_: WEEKMAP_,
            weekListe: [
                {
                    hour: 8,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 8,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 9,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 9,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 10,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 10,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 11,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 11,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 12,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 12,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 13,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 13,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 14,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 14,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 15,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 15,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 16,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 16,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 17,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 17,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 18,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 18,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 19,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 19,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 20,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 20,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 21,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 21,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 22,
                    period: 1,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
                {
                    hour: 22,
                    period: 2,
                    mon: {},
                    tues: {},
                    wed: {},
                    thur: {},
                    fri: {},
                    sat: {},
                    sun: {},
                    col: []
                },
            ],
            weektitle: [
                {
                    name: "hour",
                },
                {
                    name: "sun",
                },
                {
                    name: "mon",
                },
                {
                    name: "tues",
                },
                {
                    name: "wed",
                },
                {
                    name: "thur",
                },
                {
                    name: "fri",
                },
                {
                    name: "sat",
                },
            ],
            week_res: [[2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0,]],
            weekArr: ["sun", "mon", "tues", "wed", "thur", "fri", "sat",],
            monthEnglish: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],

            startTime: "",
            nowYear: "",
            nowMonth: "",
            endTime: "",

            isRepeatDate: false,

            realRepeatDate: {//真实渲染的 周期性课程 的框框
                courseId: '',
                isRepeatDate: false,
                repeatType: 0,
                limitType: 0,
                times: 0,
                closingDate: '',
                startDate: ''
            },
            re_data: [],//表格数据
            scheduleData: [],//真正渲染到表格的数据
            popoverVisible: false,
            colorList: [
                '#fcc081',
                '#d3aef4',
                '#f9aecd',
                '#fe9f9d',
                '#fec461',
                '#80cff8',
                '#acbefe',
            ],
            classColorMap: {

            }
        }
    },
    mounted() {
        this.changeWeek('now-week');
        this.changeTime();
        this.initTableData();
    },

    methods: {
        minMyPopper() {

            this.popoverVisible = false;
        },
        //获取我自己的课程数据
        async getScheduleList() {
            let startdate = this.arr[0];
            let enddate = this.arr[6];
            await this.$api.courseApi.getCalendar({ startdate, enddate }).then(res => {
                if (res.status === '0') {
                    this.re_data = res.data;
                }
            })
        },
        //更新表格数据
        initTableData() {
            this.getScheduleList().then(() => {
                for (let item of this.weekListe) {
                    item.mon = {};
                    item.tues = {};
                    item.wed = {};
                    item.thur = {};
                    item.fri = {};
                    item.sat = {};
                    item.sun = {};
                }
                this.week_res = [[2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 0,]];

                //日历对象转化 异步问题
                for (let item of this.re_data) {
                    this.classColorMap[item.cId] = 0;
                    this.weekListe[item.hour * 2 + item.period - 17][item.week] = item;
                    for (let i = 1; i < item.slot; i++) {
                        this.weekListe[item.hour * 2 + item.period - 17 + i][item.week] = item;
                    }
                }
                let tempIndex = 0;
                for (let key in this.classColorMap) {
                    this.classColorMap[key] = this.colorList[tempIndex];
                    tempIndex++
                    if (tempIndex >= this.colorList.length) {
                        tempIndex = 0;
                    }
                }

                for (let key of this.weekArr) {
                    let t_arr = []
                    for (let i = 0; i < this.weekListe.length; i++) {
                        let j = 1;
                        if (key === 'fri') {
                            // console.log(i);
                        }
                        if (this.weekListe[i][key].id) {//如果有课程值
                            while (this.weekListe[i + 1][key] &&
                                // (key === 'fri' && console.log(i) || true) &&
                                this.weekListe[++i][key].id &&
                                this.weekListe[i][key].id === this.weekListe[i - 1][key].id) {
                                j++
                            }
                            t_arr.push(j);
                            if (j > 1) {
                                i--;
                            }
                            for (let num = 0; num < j - 1; num++) {
                                t_arr.push(0);
                            }
                        } else {
                            t_arr.push(1);
                        }
                    }
                    this.week_res.push(t_arr);
                }
                this.scheduleData = this.weekListe;
            });
        },

        getMonDate(data) {
            var d = new Date(data);
            var day = d.getDay();
            var date = d.getDate();
            if (day == 0) return d;
            if (day == 6) d.setDate(date + 6);
            else d.setDate(date - day + 1);
            return d;
        },
        nowDate(type, dates, date) {
            var now = "";
            if (date) {
                now = new Date(date);
            } else {
                now = new Date();
            }

            var nowTime = now.getTime();
            var day = now.getDay();
            var longTime = 24 * 60 * 60 * 1000;
            var n = longTime * 7 * (dates || 0);
            if (type == "s") {
                var dd = nowTime - (day - 0) * longTime + n;
            }
            if (type == "e") {
                var dd = nowTime + (6 - day) * longTime + n;
            }
            dd = new Date(dd);

            var y = dd.getFullYear();
            var m = dd.getMonth() + 1;
            var d = dd.getDate();
            m = m < 10 ? "0" + m : m;
            d = d < 10 ? "0" + d : d;
            var day = y + "-" + m + "-" + d;
            
            return day;
        },

        objectSpanMethod({ row, column, rowIndex, columnIndex }) {

            // 得到行合并的数据
            const rowNum = this.week_res[columnIndex][rowIndex];
            // 列合并
            const colNum = rowNum > 0 ? 1 : 0;
            // 当前位置的行合并和列合并数据
            return {
                rowspan: rowNum,
                colspan: colNum,
            };
        },
        /**
         * @desc 上一周下一周
         * @params type : now-week 下一周
         * @params type : prev-week 上一周
         * @params type : next-week 下一周
         */
        changeWeek(type) {
            
            var d = null;
            if (type === 'prev-week') {
                var d = this.getMonDate(this.nowDate("s", -1, this.arr[0]));//获取周日的日期 标准日期格式
            } else if (type === 'next-week') {
                var d = this.getMonDate(this.nowDate("s", 1, this.arr[6]));
            }else if(type === 'now-week'){
                var d = this.getMonDate(this.nowDate("s"));
            } else {
                throw new Error("参数无效");
            }
            var arr = [];
            for (var i = 0; i < 7; i++) {
                
                let mm = d.getMonth() + 1
                let mm_ = mm < 10?'0'+mm:mm
                
                let dd = d.getDate()
                let dd_ = dd < 10?'0'+dd:dd

                arr.push(d.getFullYear() + "-" + mm_ + "-" +dd_);
                d.setDate(dd + 1);
            }
            this.arr = arr;
            this.changeTime();
            this.initTableData();
        },

        changeTime() {
            let start = this.arr[0];
            let timelist = start.split("-");

            this.startTime = timelist[1] + '/' + timelist[2];

            let start2 = this.arr[6];
            let timelist1 = start2.split("-");
            this.endTime = timelist1[1] + '/' + timelist1[2];

            this.nowMonth = parseInt(timelist[1]);
            this.nowYear = timelist[0];
        },
        //周期性课程，保存
        handleRepeatDate(courseId) {

            let circle = this.realRepeatDate.repeatType === 0 ? 1 : 7;
            let startDate = this.realRepeatDate.startDate;//开始日期
            let times = this.realRepeatDate.times;//次数
            let t_date = courseId.split('-');
            let index = parseInt(t_date[3]) * 2 + parseInt(t_date[4]) - 17;
            let class_slot = 0
            for (let item of this.tempSchedule) {
                if (item.tempId === courseId) {
                    class_slot = item.slot;
                    break
                }
            }
            for (let i = 0; i < times; i++) {
                for (let j = 0; j < class_slot; j++) {
                    this.weekListe[index + j].col = []
                }
            }
            for (let i = 0; i < times; i++) {
                for (let j = 0; j < class_slot; j++) {
                    this.weekListe[index + j].col.push(format(new Date(new Date(startDate).valueOf() + circle * i * 24 * 60 * 60 * 1000), 'YYYY-MM-DD'));
                    
                    this.weekListe[index + j].col = [...new Set(this.weekListe[index + j].col)]
                }
            }
                // console.log(this.weekListe[index].col);
            this.popoverVisible = false
            // console.log(this.weekListe[t_date[3] * 2 + t_date[4] - 17].col);


        },

        clickSchedule(row, column, cell, event) {

            if (column.label === 'Time') return
            if (row[WEEKMAP_EN[column.label]].id) {
                this.$message.error('There is already a class here!');
                return
            }

            for (let i = 0; i < this.weekListe.length; i++) {
                if (row.hour === this.weekListe[i].hour && row.period === this.weekListe[i].period) {

                    if (this.weekListe[i].col.indexOf(this.arr[WEEK2DATE[column.label]]) === -1) {

                        //如果紧跟着一节课，则不能选
                        for (let j = 1; j < this.classSlot; j++) {
                            if (this.weekListe[i + j] && this.weekListe[i + j][WEEKMAP_EN[column.label]].id) {
                                this.$message.error('Course duration error.');
                                return
                            }
                        }

                        //当前时间+1h 以前的课程不能选
                        let t_date = new Date(this.arr[WEEK2DATE[column.label]] + ' ' + row.hour + ':' + (row.period === 1 ? '00' : '30') + ':00').getTime();//指定日期+选中时间 
                        let t_now_hour = new Date(new Date() + 1000 * 60 * 60 * 1).getTime();//当前时间+1h
                        if (t_date < t_now_hour) {
                            this.$message.error('Course schedule conflict.');
                            return;
                        }
                        if (!this.multiple) {//单选情况下
                            for (let item of this.weekListe) {
                                item.col = [];
                            }
                        }
                        for (let j = 0; j < this.classSlot; j++) {
                            this.weekListe[i + j] && this.weekListe[i + j].col.push(this.arr[WEEK2DATE[column.label]]);
                            this.weekListe[i + j] && (this.weekListe[i + j].col = [...new Set(this.weekListe[i + j].col)]);
                        }
                    } else {

                        for (let j = 0; j < this.classSlot; j++) {
                            this.weekListe[i + j] && this.weekListe[i + j].col.remove(this.arr[WEEK2DATE[column.label]]);
                        }

                        // this.weekListe[i].col.remove(this.arr[WEEK2DATE[column.label]]);
                        // if (this.weekListe[i + 1])
                        //     this.weekListe[i + 1].col.remove(this.arr[WEEK2DATE[column.label]]);
                    }

                    break
                }

            }
        },
        setCellStyle({ row, column, rowIndex, columnIndex }) {

            if (column.label !== 'Time') {
                // console.log(column)
                //highlightTable
                for (let item of this.highlightTable) {  //高亮展示的课程
                    if (item.week === column.property &&
                        row.period === item.period &&
                        row.hour === item.hour &&
                        new Date(this.arr[WEEK2DATE[column.label]]).getDate() === new Date(item.apdate).getDate()) {
                        return {
                            background: '#F48C06',
                            color: '#fff',
                        }
                    }
                }

                if (row[WEEKMAP_EN[column.label]].id) { // 已经存在的课程

                    return {

                        background: this.classColorMap[row[WEEKMAP_EN[column.label]].cId],
                        // background: '#f7c88b',
                        opacity: 1,
                        color: '#fff',
                        cursor: 'not-allowed',
                        'pointer-events': 'none',
                    }
                }
                let t_date = new Date(this.arr[WEEK2DATE[column.label]] + ' ' + row.hour + ':' + (row.period === 1 ? '00' : '30') + ':00').getTime();//指定日期+选中时间 
                let t_now_hour = new Date(new Date() + 1000 * 60 * 60 * 1).getTime();//当前时间+1h

                if (t_date < t_now_hour) { // 时间在当前时间之前的不能选
                    return {
                        background: '#F5F7FA',
                        cursor: 'not-allowed',
                        'pointer-events': 'none',
                    }
                }
                if (row.col.indexOf(this.arr[WEEK2DATE[column.label]]) !== -1) {
                    return {
                        background: '#F48C06',
                        color: '#fff',
                        'text-align': 'right'
                    }
                }
            }
            return {

            }
        },
        mouseclick(row, column, cell, event) {

            if (!this.multiple) {//单选情况下
                return
            }

            if (column.label !== 'Time') {

                if (row.col.indexOf(this.arr[WEEK2DATE[column.label]]) !== -1) {

                    for (let item of this.repeatDate) {
                        if (item.courseId === this.arr[WEEK2DATE[column.label]] + '-' + row.hour + '-' + row.period) {
                            this.realRepeatDate = item;
                            break
                        }
                    }
                    event.preventDefault();//屏蔽元素发生默认行为
                    let popover = document.getElementById('my_popover');
                    cell.children[0].appendChild(popover);
                    cell.style.padding = '0'
                    popover.style.visibility = 'visible';
                    this.popoverVisible = true;
                    this.$nextTick(() => {
                        this.$refs['my_popover'].createPopper();
                    })
                }
            }

        },
        upDatePopover() {
            this.$nextTick(() => {
                this.$refs['my_popover'].createPopper();
            })
        },
        //清空选择
        clearCourse() {
            for (let item of this.weekListe) {
                item.col = [];
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.schedule-table {
    .my-popper {
        padding: 20px;
        background: #fff;
        display: inline-block;
        border-radius: 8px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        position: absolute;
        display: none;
    }

    .table-body {
        padding-bottom: 2px;
    }
    .time-slot-box {
        background: #ffffff;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 24px;
        padding: 40px 32px;
        box-sizing: border-box;

        margin-bottom: 56px;

        /deep/.el-table__header tr,
        .el-table__header th {
            padding: 0;
            height: 40px;
        }
        /deep/.el-table__body tr,
        .el-table__body td {
            padding: 0;
            height: 48px;
        }
        /deep/.el-table::before {
            height: 0px;
        }
        .time-slot-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .now-date {
                height: 25px;
                font-size: 18px;
                font-weight: 600;
                color: #f48c06;
                line-height: 25px;
            }
            .time-operate {
                .time-slot-oprate {
                    font-size: 14px;
                    margin-right: 8px;
                    color: #f48c06;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
                i {
                    cursor: pointer;
                }
            }
        }
    }
}
.schedule-popover {
    padding: vw(24) vw(32);
    box-sizing: border-box;
    width: 340px;
    .schedule-popover-title {
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #201002;
        line-height: 33px;
        margin-bottom: 16px;
    }
    .schedule-popover-item {
        margin-top: 4px;
        font-weight: 600;
        font-size: 14px;
        color: #201002;
        .el-button {
            border: none;
            color: #ffffff;
            background: #f48c06;
            margin-top: 20px;
            border-radius: 8px;
            height: 32px;
            display: flex;
            align-items: center;
        }
    }
}
</style>